import type React from 'react';

import styled from '@emotion/styled';

import {
  buttonAppearance,
  primaryButtonDisabledAppearance,
  type ButtonSize,
  type ButtonVariant,
} from './utils/button_appearance';

export type { ButtonSize, ButtonVariant };

export type ButtonProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Button = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'size',
})<ButtonProps>`
  ${({ variant, size }) => buttonAppearance({ variant, size })}
  ${({ variant, disabled }) => variant === 'primary' && primaryButtonDisabledAppearance(disabled)}
`;
